import { Modal, ModalContent, ModalBody, Button, useDisclosure } from "@nextui-org/react";
import CameraCanvas from './CameraCanvas'

const Camera = ({ overlay, size }) => {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();

    return (
        <>
            <p className="text-center">لطفا در فاصله دو متری از دیوار قرار بگیرید</p>
            <div className="centerOfParent cursor-pointer my-4">
                <Button onPress={onOpen}>استفاده از دوربین</Button>
            </div>
            <Modal size={"full"} isOpen={isOpen} onOpenChange={onOpenChange}
                closeButton={ // Custom close button
                    <Button isIconOnly auto flat variant="light" onPress={() => onOpenChange(false)}>
                        <svg fill="red" stroke="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"></path></svg>
                    </Button>
                }>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalBody className="!px-0 !pt-0">
                                <CameraCanvas overlay={overlay} size={size} />
                            </ModalBody>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default Camera;
